import { INITIALIZE_ENGINES, ACCEPT_ENGINES } from './analytics.actions';
import { enginesNamesToEnabledStateMap } from './analytics.utils';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_ENGINES: {
      return {
        ...state,
        ...enginesNamesToEnabledStateMap(action.engines, false),
      };
    }
    case ACCEPT_ENGINES: {
      return {
        ...state,
        ...enginesNamesToEnabledStateMap(action.engines, true),
      };
    }
    default: {
      return state;
    }
  }
};
